export var SAVE_ACCEPT_COOKIES='SAVE_ACCEPT_COOKIES';